var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3704_53946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2859 1.69922H1.85648C1.11251 1.69922 0.509399 2.30233 0.509399 3.04629V14.7378C0.509399 15.4818 1.11251 16.0849 1.85648 16.0849H10.2859",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6546 11.2029C12.5082 11.3493 12.5082 11.5868 12.6546 11.7332C12.8011 11.8797 13.0385 11.8797 13.1849 11.7332L15.7601 9.15806C15.9066 9.01161 15.9066 8.77418 15.7601 8.62773L13.1849 6.05257C13.0385 5.90612 12.8011 5.90612 12.6546 6.05257C12.5082 6.19901 12.5082 6.43645 12.6546 6.5829L14.6079 8.5362H6.56029C6.35318 8.5362 6.18529 8.7041 6.18529 8.9112C6.18529 9.11831 6.35318 9.2862 6.56029 9.2862H14.5713L12.6546 11.2029Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3704_53946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOutline);
export default __webpack_public_path__ + "static/media/logout-outline.288d4f15eb7375570bbd39886a1bfb61.svg";
export { ForwardRef as ReactComponent };